export default "__VITE_ASSET__BdIxV3yj__"